import {enumType} from 'common/enumType';

export const SearchFieldType = enumType({
   // NONE: '<NONE>',
   NAME: 'Name Field',
   ALL: 'All Fields',
});
